<script lang="ts" setup>
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { Link, LinkTarget, LinkVariant } from '../Link';
  import type {
    ExternalLinkProps,
    ExternalLinkSlots,
  } from './ExternalLink.types';

  withDefaults(defineProps<ExternalLinkProps>(), {
    variant: LinkVariant.Primary,
    disabled: false,
  });

  const slots = defineSlots<ExternalLinkSlots>();
</script>

<template>
  <Link
    :href="href"
    :label="label"
    :variant="variant"
    :disabled="disabled"
    :target="LinkTarget.Blank"
    :icon-right="TUNDR_ICONS.EXTERNAL_LINK"
    :test-id="testId"
  >
    <slot v-if="slots.default" />
  </Link>
</template>
